import {
  Card,
  CardContent,
  Grid,
  Select as MuiSelect,
  TextField as MuiTextField,
} from "@mui/material";
import Button from "@mui/material/Button";
import { spacing } from "@mui/system";
import React, { useState } from "react";
import styled from "styled-components";

const Select = styled(MuiSelect)(spacing);
const TextField = styled(MuiTextField)(spacing);

export default (props) => {
  const handleClose = props.handleClose;
  const submitNewOwner = props.submitNewOwner;

  const [editOwnerObj, setEditOwnerObj] = useState({});
  const [editOwnerAddrObj, setEditOwnerAddrObj] = useState({});

  const onOwnerFieldChange = (e) => {
    setEditOwnerObj(
      Object.assign({}, editOwnerObj, { [e.target.name]: e.target.value })
    );
  };

  const onAddrFieldChange = (e) => {
    setEditOwnerAddrObj(
      Object.assign({}, editOwnerAddrObj, { [e.target.name]: e.target.value })
    );
  };

  const action = async () => {
    let editObj = Object.assign(
      {},
      { addressInfo: editOwnerAddrObj },
      { ownerInfo: editOwnerObj }
    );

    await submitNewOwner(editObj);
  };

  return (
    <div>
      <Card>
        <CardContent>
          {/* PropertyManager Details */}
          <Grid container spacing={2}>
            <h3>Owner Info:</h3>
            <Grid container item spacing={2}>
              <Grid item sm={6} xs={12}>
                <TextField
                  label="Owner Name"
                  type="text"
                  onChange={onOwnerFieldChange}
                  name="name"
                  //required
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item sm={6} xs={12}>
                <TextField
                  label="Contact Name"
                  type="text"
                  onChange={onOwnerFieldChange}
                  name="contactName"
                  //required
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item sm={6} xs={12}>
                <TextField
                  label="Address 1"
                  type="text"
                  onChange={onAddrFieldChange}
                  name="address1"
                  //required
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item sm={6} xs={12}>
                <TextField
                  label="Address 2"
                  type="text"
                  onChange={onAddrFieldChange}
                  name="address2"
                  //required
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item sm={6} xs={12}>
                <TextField
                  label="City"
                  type="text"
                  onChange={onAddrFieldChange}
                  name="city"
                  //required
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
            </Grid>
            <Grid item sm={3} xs={6}>
              <TextField
                label="State"
                type="text"
                onChange={onAddrFieldChange}
                name="state"
                //required
                fullWidth
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item sm={3} xs={6}>
              <TextField
                label="Zip"
                type="text"
                onChange={onAddrFieldChange}
                name="zip"
                //required
                fullWidth
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item sm={3} xs={6}>
              <TextField
                label="Customer Service Amount"
                type="number"
                onChange={onOwnerFieldChange}
                name="customerServiceAmount"
                //required
                fullWidth
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item sm={3} xs={6}>
              <TextField
                label="Distribution Fee Amount"
                type="number"
                onChange={onOwnerFieldChange}
                name="distFeeAmt"
                //required
                fullWidth
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <Grid item sm={3} xs={6}>
              <TextField
                label="Profit Share %"
                type="number"
                onChange={onOwnerFieldChange}
                name="profitSharePercent"
                //required
                fullWidth
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <Grid item sm={3} xs={6}>
              <TextField
                label="Accounting ID"
                type="text"
                onChange={onOwnerFieldChange}
                name="glCode"
                //required
                fullWidth
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <h3>Mailing Address Info:</h3>

            <Grid container item spacing={2}>
              <Grid item xs={12} />
              <Grid item sm={6} xs={12}>
                <TextField
                  label="Mailing Name"
                  type="text"
                  onChange={onOwnerFieldChange}
                  name="mailingName"
                  //required
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item sm={6} xs={12}>
                <TextField
                  label="Mailing Contact Name"
                  type="text"
                  onChange={onOwnerFieldChange}
                  name="mailingContactName"
                  //required
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
            </Grid>
            <Grid container item>
              <Grid item xs={12}>
                <TextField
                  label="Notes"
                  type="text"
                  onChange={onOwnerFieldChange}
                  name="notes"
                  multiline
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
            </Grid>

            <Grid container item spacing={2} justify={"flex-end"}>
              <Grid item>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => {
                    action();
                    handleClose();
                  }}
                >
                  Save
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </div>
  );
};
